module.exports = __webpack_public_path__ + "img/1.ffcb30db.png";